import { basePost, baseGet } from "../api/base";

import apiEndPointList from "../constant/apiEndPointsList";

const projectServices = {
    getPublicTourModeConfig: async (idPath: string, linkId: string) => {
        const safeLinkId = linkId && linkId !== '0' && /^\d+$/.test(linkId) ? linkId : '1';
        try {
            const response = await baseGet<{ success: boolean; data: unknown }>({
                endpoint: `/v1/projects/tour-mode-config/public?id_path=${encodeURIComponent(idPath)}&link_id=${encodeURIComponent(safeLinkId)}`,
            });
            if (!response.data?.success) {
                return null;
            }
            return response.data.data;
        } catch (error) {
            console.warn('Unable to load Tour Mode configuration, fallback to default:', error);
            return null;
        }
    },
    // get id path by name path 
    getIdByNamePath: async ({ name_path }: { name_path: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.idPath.GET_ID_BY_NAME_PATH(name_path),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi làm mới token");
        }

        return response?.data;
    },
    getIdByFullNamePath: async ({ name_path, includeLoadingLogo = false }: { name_path: string, includeLoadingLogo?: boolean }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.idPath.GET_ID_BY_FULL_NAME_PATH(name_path) + (includeLoadingLogo ? '&include_loading_logo=1' : ''),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi làm mới token");
        }

        return response?.data;
    },
    // getIdByNamePath: async ({ name_path }: { name_path: string }) => {
    //     let response = null;
    //     try {
    //         response = await baseGet({
    //             endpoint: apiEndPointList.idPath.GET_ID_BY_NAME_PATH(name_path),
    //         });
    //     } catch (err: any) {
    //         if (err.response?.data?.error) {
    //             throw new Error(err.response.data.error);
    //         }
    //         throw new Error("Có lỗi xảy ra khi làm mới token");
    //     }

    //     return response;
    // },

    // get tour.xml by id path 
    getTourByIdPath: async ({ id_path }: { id_path: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.idPath.GET_TOUR_BY_ID_PATH(id_path),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi làm mới token");
        }

        return response?.data;
    },


    // get SETTING by id path 
    getAllVariableSettingAndValue: async ({ id_path, sublink }: { id_path: string, sublink: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.idPath.GET_ALL_VARIABLE_SETTING_AND_VALUE(id_path, sublink),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi làm mới token");
        }

        return response?.data;
    },

    getAllVariableSettingAndValueFallback: async ({ id_path, sublink }: { id_path: string, sublink: string }) => {
        try {
            const [cat1Res, metaRes, cat2Res, defaultRes] = await Promise.allSettled([
                baseGet({
                    endpoint: apiEndPointList.idPath.GET_ALL_VARIABLE_SETTING_AND_VALUE_FALLBACK(id_path, sublink),
                }),
                baseGet({
                    endpoint: apiEndPointList.idPath.GET_ALL_VARIABLE_SETTING_AND_VALUE_FALLBACK_BY_CATEGORY(id_path, sublink, 'Meta'),
                }),
                baseGet({
                    endpoint: apiEndPointList.idPath.GET_ALL_VARIABLE_SETTING_AND_VALUE_FALLBACK_BY_CATEGORY(id_path, sublink, 2),
                }),
                baseGet({
                    endpoint: apiEndPointList.idPath.GET_ALL_VARIABLE_SETTING_AND_VALUE_FALLBACK_BY_CATEGORY(id_path, sublink, 'Default'),
                }),
            ]);

            const cat1Data = cat1Res.status === 'fulfilled' ? (cat1Res.value as any)?.data?.data : null;
            const metaData = metaRes.status === 'fulfilled' ? (metaRes.value as any)?.data?.data : null;
            const cat2Data = cat2Res.status === 'fulfilled' ? (cat2Res.value as any)?.data?.data : null;
            const defaultData = defaultRes.status === 'fulfilled' ? (defaultRes.value as any)?.data?.data : null;

            if (!cat1Data && !metaData && !cat2Data && !defaultData) {
                if (cat1Res.status === 'rejected') {
                    const err = cat1Res.reason as any;
                    if (err?.response?.data?.error) {
                        throw new Error(err.response.data.error);
                    }
                }
                return { success: false, data: {} };
            }

            const merged: Record<string, any> = { ...(cat1Data || {}) };

            const mergeCategory = (source: Record<string, any> | null) => {
                if (!source) return;
                for (const [key, value] of Object.entries(source)) {
                    if (value !== null && value !== undefined) {
                        merged[key] = value;
                    } else if (merged[key] === undefined) {
                        merged[key] = value;
                    }
                }
            };

            mergeCategory(cat2Data);
            mergeCategory(defaultData);
            mergeCategory(metaData);

            return {
                success: true,
                error: false,
                data: merged,
            };
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error(err.message || "Có lỗi xảy ra khi lấy cài đặt dự án");
        }
    },


    // Lấy toàn bộ biến setting (key-value, có fallback) của một nhóm, ví dụ 'Noti'
    getSettingsByCategory: async ({ id_path, sublink, category }: { id_path: string, sublink: string, category: string | number }): Promise<Record<string, any>> => {
        try {
            const res = await baseGet({
                endpoint: apiEndPointList.idPath.GET_ALL_VARIABLE_SETTING_AND_VALUE_FALLBACK_BY_CATEGORY(id_path, sublink, category),
            });
            return (res as any)?.data?.data || {};
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error(err.message || "Có lỗi xảy ra khi lấy cài đặt theo nhóm");
        }
    },

    getAllLanguageByIdPath: async ({ id_path }: { id_path: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.language.GET_ALL_LANGUAGE_BY_ID_PATH(id_path),
            });
            
            // Intercept and filter languages
            if (response && response.data && response.data.success && Array.isArray(response.data.data)) {
                let isPreviewMode = false;
                if (typeof window !== 'undefined') {
                    const urlParams = new URLSearchParams(window.location.search);
                    const previewParam = urlParams.get('preview');
                    if (previewParam === 'true') {
                        isPreviewMode = true;
                    } else if (previewParam === 'false') {
                        isPreviewMode = false;
                    } else {
                        isPreviewMode = sessionStorage.getItem('previewMode') === 'true';
                    }
                }
                if (!isPreviewMode) {
                    response.data.data = response.data.data.filter((lang: any) => lang.is_public !== 0);
                }
            }
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi làm mới token");
        }

        return response?.data;
    },
    getAllProject: async () => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.project.GET_ALL_PROJECTS,
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi tải danh sách dự án");
        }

        return response?.data;
    },
    getFieldProject: async () => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.project.GET_PROJECT_FIELDS,
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi lấy danh sách fields");
        }

        return response?.data;
    },
    getSettingByUuid: async ({ id_path, uuid, sublink, language_id }: {
        id_path: string,
        uuid: string,
        sublink?: string,
        language_id?: string,
    }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.idPath.GET_SETTING_BY_UUID(id_path, uuid, sublink, language_id),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi lấy danh sách fields");
        }

        return response?.data;
    },
    getLanguageDefault: async ({ id_path }: { id_path: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.language.GET_LANGUAGE_DEFAULT(id_path),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi làm mới token");
        }

        return response?.data;
    },
    getProjectById: async ({ id }: { id: string }) => {
        let response: { data?: any } | null = null;
        try {
            response = await baseGet({
                endpoint: apiEndPointList.project.GET_PROJECT_BY_ID(id),
            });
        } catch (err: any) {
            if (err.response?.data?.error) {
                throw new Error(err.response.data.error);
            }
            throw new Error("Có lỗi xảy ra khi lấy thông tin dự án");
        }

        return response?.data;
    },
}

export default projectServices;
